export enum DeviceType {
  "mobile" = 1,
  "watch" = 2,
  "earbuds" = 3,
  "notebook" = 4
}
